export default {
  methods: {
    randomString (length) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      // Sorteio criptográfico; bytes ≥ 248 são descartados para que os 62 caracteres tenham a mesma chance (248 = 4 × 62).
      const limit = 256 - (256 % chars.length)
      const bytes = new Uint8Array(length * 2)

      let str = ''

      while (str.length < length) {
        crypto.getRandomValues(bytes)

        for (let i = 0; i < bytes.length && str.length < length; i++) {
          if (bytes[i] < limit) str += chars.charAt(bytes[i] % chars.length)
        }
      }

      return str
    },
    checkDomain (domain) {
      if (!domain) return false

      const re = /^[a-z0-9.-]+$/

      return re.test(domain)
    },
    checkUrl (link) {
      try {
        const url = new URL(link)
        return this.checkDomain(url.hostname)
      } catch (e) {
        return false
      }
    }
  }
}
